import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const PaymentDetail = (props) => {
  const [ paymentSettings, setPaymentSettings ] = useState(null);
  const [ amount, setAmount ] = useState(0);
  const { t } = useTranslation();

  // set props value
  useEffect(() => {
    setPaymentSettings(props.paymentSettings);
    setAmount(props.amount);
  }, [props]);

  if(paymentSettings && amount){
    return(
      <>
        <div className="detail price">
          <label>{ t('Price') }</label>
          <div className="price-full">
            <div className="currency">{ paymentSettings.currency_code }</div>
            <div className="price"> { amount }</div>
          </div>
        </div>

        <div className="detail payment-terms">
          <label>{ t('Payment Terms') }</label>
          <div className="payment-terms-content">
            { paymentSettings.payment_terms_message }
          </div>
        </div>
      </>
    );
  }
  else return null;
};

export default PaymentDetail;